import { DatePivotParams } from "../../entities/date_pivot_params";

// Canonical (apostrophe-free) status labels sent to the backend filter.
// Keep in sync with NEW_POS_TO_PLACE in the supply_walk_editable_goodchop transform.
export const NEEDS_REVIEW_NEW_POS_TO_PLACE = "Needs Review: New POs to Place";
export const NEEDS_REVIEW_OPEN_PO_MODIFICATIONS =
  "Needs Review: Open PO Modifications";
// The two kinds of row the send list holds. These are labels the view transform
// writes into po_type, not values of any source column, so the dataset schema
// cannot offer them as filter options — they are stated here, and must match
// supply_walk_editable_goodchop exactly or the filter matches nothing.
export const PO_TYPE_NEW = "New PO";
export const PO_TYPE_CHANGE = "Change to open PO";

// Stands in for the number a purchase order gets when it is placed. A row
// carrying it is an order to place; anything else is an order already with a
// vendor.
export const TBD_PO_ID = "TBD";
export const OPEN_STATUS = "Open";
export const APPROVED_STATUS = "Approved";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "day",
  segments: [],
  filters: [["status", "in", ["Needs Review"]]],
};

export const defaultConfigGoodchop: DatePivotParams = {
  dateHierarchy: "day",
  segments: [],
  filters: [["status", "in", [NEEDS_REVIEW_NEW_POS_TO_PLACE]]],
};
